import { useCallback, useEffect, useState } from 'react';
import { getAxiosClient } from '#shared/api/axiosClient';
const useFetchGlossaryId = id => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const fetchData = useCallback(async id => {
    if (!id) return;
    setLoading(true);
    try {
      const axiosClient = getAxiosClient();
      const response = await axiosClient.get(`glossary/${id}`);
      setData(response.data);
      setError(null);
    } catch (err) {
      setError(err);
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [id]);
  useEffect(() => {
    fetchData(id);
  }, [fetchData, id]);
  return {
    data,
    error,
    loading,
    refetch: fetchData,
    fetchData
  };
};
export default useFetchGlossaryId;